import React from 'react';
import SocialAppFooter from '../../components/Grid/SocialSection/SocialSection';
import ServiceFooter from '../../components/Grid/ServiceSection/ServiceSection';
import { getSocialMediaAccounts } from '../../utils/socialAccounts';
var socials = getSocialMediaAccounts('habitat');

var grid = function grid(nativeLazy) {
  return [{
    title: 'Follow us',
    component: /*#__PURE__*/React.createElement(SocialAppFooter, {
      nativeLazy: nativeLazy,
      socials: socials
    })
  }, {
    title: 'Payment methods',
    component: /*#__PURE__*/React.createElement(ServiceFooter, {
      nativeLazy: nativeLazy
    })
  }];
};

export default grid;